import React from 'react';
import HeaderLinks from "./HeaderLinks";
import HeaderLogin from "./HeaderLogin";


const HeaderSwitch = (props) => {
  if (props.isAuthenticated) {
    return <HeaderLinks clickedLogout={props.clickedLogout}/>;
  }
    return <HeaderLogin />;
}

export default HeaderSwitch;


// WEBPACK FOOTER //
// ./src/components/Header/HeaderSwitch.js